import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'

import { app } from './modules/app'
import { lostProperties } from './modules/lostProperties'
import { categoryGroups } from './modules/categoryGroups'
import { categories } from './modules/categories'
import { transportationTypes } from './modules/transportationTypes'
import { mailTemplates } from './modules/mailTemplates'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [pathify.plugin],
  modules: {
    app,
    lostProperties,
    categoryGroups,
    categories,
    transportationTypes,
    mailTemplates,
  },
})
